"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MetaControl = /** @class */ (function () {
    function MetaControl(selector, name, template, columnCount, isHeader, iconInfo, settings, groups, defaultActions, isFieldBound, moduleKey, isSubwayMap, nameKey, height) {
        if (columnCount === void 0) { columnCount = 4; }
        if (isHeader === void 0) { isHeader = false; }
        this.selector = selector;
        this.name = name;
        this.template = template;
        this.isHeader = isHeader;
        this.iconInfo = iconInfo;
        this.settings = settings;
        this.groups = groups;
        this.defaultActions = defaultActions;
        this.isFieldBound = isFieldBound;
        this.moduleKey = moduleKey;
        this.isSubwayMap = isSubwayMap;
        this.nameKey = nameKey;
        this.height = height;
        this.columnCount = columnCount ? columnCount : 4;
    }
    return MetaControl;
}());
exports.MetaControl = MetaControl;
//# sourceMappingURL=meta-control.js.map